import { styled } from 'baseui'

export const MessageCardRoot = styled<'article', { $active?: boolean }>('article', ({ $theme, $active }) => ({
  display: 'flex',
  flexDirection: 'column',
  minWidth: 0,
  backgroundColor: $active ? $theme.colors.primary : $theme.colors.bg050,
  borderRadius: $theme.borders.radius400,
  boxShadow: $active ? $theme.lighting.shadow400 : 'none',
  overflow: 'hidden',
  transitionProperty: 'background-color, box-shadow',
  transitionDuration: '150ms',
  ':hover': {
    backgroundColor: $active ? $theme.colors.primary : $theme.colors.bg100,
  },
}))

export const CardHeader = styled('div', {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  minHeight: '3.25rem',
  height: '100%',
  boxSizing: 'border-box',
  padding: '0.5rem 0.75rem',
})

export const CardTitleButton = styled<'button', { $active?: boolean }>('button', ({ $theme, $active }) => ({
  minWidth: 0,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  gap: '0.375rem',
  background: 'transparent',
  borderTopWidth: 0,
  borderRightWidth: 0,
  borderBottomWidth: 0,
  borderLeftWidth: 0,
  padding: 0,
  textAlign: 'center',
  cursor: 'pointer',
  color: $active ? $theme.colors.white : $theme.colors.primary,
  ...$theme.typography.font550,
  ':hover': {
    color: $active ? $theme.colors.white : $theme.colors.buttonPrimaryHover,
  },
}))

export const CardTitleText = styled('span', {
  minWidth: 0,
  overflowWrap: 'anywhere',
})
